import React from 'react';

function ContactContent() {
  return (
    <section className="contact_area section_gap">
        <div className="container">
            <div className="row">
                <div className="col-lg-3">
                    <div className="contact_info">
                        <div className="info_item">
                            <i className="lnr lnr-home"></i>
                            <h6>Zaporizhia Region, Ukraine</h6>
                            <p>Dai Phuc District</p>
                        </div>
                        <div className="info_item">
                            <i className="lnr lnr-phone-handset"></i>
                            <h6><a href="tel:754-264-8668">‪‪(754) 264-8668‬</a></h6>
                            <p>Mon to Fri 9am to 4 pm</p>
                        </div>
                        <div className="info_item">
                            <i className="lnr lnr-envelope"></i>
                            <h6><a href="mailto:max.hotovkin@gmail.com">max.hotovkin@gmail.com</a></h6>
                            <p>Send me your message anytime!</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-9">
                    <form className="row contact_form">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input type="text" className="form-control" id="name" name="name" placeholder="Enter your name"/>
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" id="email" name="email" placeholder="Enter email address"/>
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" id="subject" name="subject" placeholder="Enter Subject"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <textarea className="form-control" name="message" id="message" rows="1" placeholder="Enter Message"></textarea>
                            </div>
                        </div>
                        <div className="col-md-12 text-right">
                            <button type="submit" value="submit" className="primary_btn">
                                <span>Send Message</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div id="mapBox" className="mapBox" 
                data-lat="47.8388" 
                data-lon="35.1396" 
                data-zoom="13" 
                data-info="No 30, Dai Duong Villas, Binh Than Street, Dai Phuc District, Zaporizhia Region, Ukraine"
                data-mlat="47.8388"
                data-mlon="35.1396">
            </div>
        </div>
    </section>
  )
}

export default ContactContent;